import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { ApiAuthService, AuthService } from '@shared';
import { firstValueFrom } from 'rxjs';

const POS_ALLOWED_ROLES = new Set(['pos']);

export const posAuthGuard: CanActivateFn = async (): Promise<boolean | import('@angular/router').UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const apiAuthService = inject(ApiAuthService);

  try {
    if (!apiAuthService.isAuthenticated()) {
      const refreshToken = apiAuthService.getRefreshToken();
      if (refreshToken) {
        try {
          await firstValueFrom(apiAuthService.refreshToken());
        } catch {
          apiAuthService.clearTokens();
          return router.createUrlTree(['/login']);
        }
      } else {
        return router.createUrlTree(['/login']);
      }
    }

    let profile = authService.profile();
    if (!profile) {
      const jwtUser = apiAuthService.getUser();
      if (jwtUser) {
        profile = apiAuthService.convertToUserProfile(jwtUser);
        authService.profile.set(profile);
      }
    }

    if (profile?.role && POS_ALLOWED_ROLES.has(profile.role)) {
      return true;
    }

    apiAuthService.clearTokens();
    return router.createUrlTree(['/login'], { queryParams: { unauthorized: '1' } });
  } catch {
    apiAuthService.clearTokens();
    return router.createUrlTree(['/login']);
  }
};
